import { createRouter, createWebHistory } from 'vue-router';
import TopPage from '@/components/TopPage.vue';
import SearchDialog from '@/components/SearchDialog.vue';
import SearchResult from '@/components/SearchResult.vue';
import TermsPage from '@/components/TermsPage.vue'
import ConditionsPage from '@/components/ConditionsPage.vue'

const routes = [
  {
    path: '/',
    name: 'TopPage',
    component: TopPage,
  },
  {
    path: '/search',
    name: 'Search',
    component: SearchDialog,
  },
  {
    path: '/search-result',
    name: 'SearchResult',
    component: SearchResult,
  },
  {
      path: '/terms',
      name: 'TermsPage',
      component: TermsPage
  },
  {
      path: '/conditions',
      name: 'ConditionsPage',
      component: ConditionsPage
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  }
});

export default router;
